import * as types from "./actionTypes";

const initialState = {
  leavePolicy: [],
  gracePolicy: null,
  loading: false,
  error: null,
  success: false, // <- Add this flag to track save success
};

const gracePolicyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_GRACE_POLICY_REQUEST:
    case types.SAVE_GRACE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false, // reset on new request
      };

    case types.FETCH_GRACE_POLICY_SUCCESS:
      return {
        ...state,
        gracePolicy: action.payload.data,
        loading: false,
      };

    case types.SAVE_GRACE_POLICY_SUCCESS:
      return {
        ...state,
        gracePolicy: action.payload,
        loading: false,
        success: true, // <- Set success to true
      };

    case types.FETCH_GRACE_POLICY_FAILURE:
    case types.SAVE_GRACE_POLICY_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      };

    case types.FETCH_LEAVE_POLICY_REQUEST:
    case types.SAVE_LEAVE_POLICY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false, // reset on new request
      };

    case types.FETCH_LEAVE_POLICY_SUCCESS:
      return {
        ...state,
        leavePolicy: action.payload.data,
        loading: false,
      };

    case types.SAVE_LEAVE_POLICY_SUCCESS:
      return {
        ...state,
        leavePolicy: action.payload,
        loading: false,
        success: true,
      };

    case types.FETCH_LEAVE_POLICY_FAILURE:
    case types.SAVE_LEAVE_POLICY_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
        success: false,
      };


    default:
      return state;
  }
};

export default gracePolicyReducer;
